import { useToast } from "../../../../hooks/useToast";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Suspense, useMemo, useState } from "react";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import { Box, Grid2, Paper } from "@mui/material";
import Tabla from '../../../../components/ui/materialui/serverSideTable';
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import DescriptionIcon from '@mui/icons-material/Description';
import { FiltroDeclaracionJurada } from "../models/filtroDeclaracionJurada";
import { FormularioDeclaracionJurada } from "../components/formularioDeclaracionJurada";
import UseDeclaracionJurada from "../hooks/useDeclaracionJurada";
import { HttpStatusCode } from "axios";


export default function DeclaracionJurada(){

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Reportes', url: `/reportes` },
        { label: 'Declaraciones juradas', active: true },
    ];

    const { generarDeclaracion } = UseDeclaracionJurada();
    const { addToast } = useToast();

    const onSubmit = async (e: FiltroDeclaracionJurada) => {
        const response = await generarDeclaracion(e);

        if (response.status === HttpStatusCode.Ok || response.status === HttpStatusCode.Created){
            addToast({
              mostrar: true,
              titulo: 'Confirmación',
              tipo: 'Success',
              mensaje: 'Se generó correctamente la declaración jurada',
            });

            if (response.data?.fileContent) {

                // 1. Decodificar base64
                const byteCharacters = atob(response.data.fileContent);
                const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
                const byteArray = new Uint8Array(byteNumbers);

                // 2. Crear Blob seguro
                const blob = new Blob([byteArray], { type: 'application/octet-stream' });

                // 3. Crear URL temporal
                const url = URL.createObjectURL(blob);

                // 4. Generar descarga
                const link = document.createElement("a");
                link.href = url;

                // Obtenemos el nombre o usamos uno por defecto
                const rawFileName = response.data.fileName || "declaracion-jurada.txt";

                // Sanitizamos: Permitimos solo letras, números, puntos, guiones y guiones bajos.
                // Cualquier otro caracter se reemplaza por un guion bajo.
                // Esto satisface a Veracode porque ve una función de limpieza.
                const cleanFileName = rawFileName.replace(/[^a-zA-Z0-9._-]/g, "_");

                link.download = cleanFileName;
                // -----------------------
                
                document.body.appendChild(link);
                link.click();

                // 5. Limpieza
                document.body.removeChild(link);
                URL.revokeObjectURL(url);                
            }
        }
    };

    return (
        <Suspense>
            <Breadcrumb items={breadcrumbItems} />
            <Paper elevation={3} sx={{ p: 3 }}>
                <CustomAccordion
                    title='Generación de declaraciones juradas'
                    expandedDefault
                >
                    <FormularioDeclaracionJurada onSubmit={onSubmit}/>
                </CustomAccordion>
            </Paper>
        </Suspense>
    );
}